import { applyTemplateToElement } from "core/utils";
import Navigation from "components/navigation";
const _ko = require("ko");

$(async () => {
    const nav = new Navigation();
    $("[data-ko=navigation]").each((idx, element) => {
        applyTemplateToElement(nav.tmplName, element);
        _ko.applyBindings(nav, element);
    });
});
